import React, { useCallback, useState } from 'react'

import { string, bool, number } from 'prop-types'

import ProfileHeader from './Components/ProfileHeader'
import StatusCard from './Components/StatusCard/StatusCard'
import Subscriptions from './Components/Subscriptions'
import { SubscriptionsProvider } from './Context/SubscriptionsContext'

function MySubscriptions({ locale = 'en', isParticipating: initialIsParticipating = false, downloadLimit = 25 }) {
  const [isParticipating, setIsParticipating] = useState(initialIsParticipating)
  const handleJoinSuccess = useCallback(() => setIsParticipating(true), [])

  return (
    <SubscriptionsProvider locale={locale}>
      <div className="my-subscriptions__container cgt-mb-20">
        <ProfileHeader locale={locale} downloadLimit={downloadLimit} />
        <StatusCard
          isParticipating={isParticipating}
          locale={locale}
          onJoinSuccess={handleJoinSuccess}
        />
        <Subscriptions />
      </div>
    </SubscriptionsProvider>
  )
}

MySubscriptions.propTypes = {
  locale: string,
  isParticipating: bool,
  downloadLimit: number,
}

export default MySubscriptions
